// extracted by mini-css-extract-plugin
export default {"navWrapper":"header_navWrapper__UpULh","topTipperLink":"header_topTipperLink__xxvTJ","topTipper":"header_topTipper__Ox93M","stripe":"header_stripe__MqVQD"};